export const getSentenceAroundHighlightedWordWithTag = (input, nearbyWordsCount = 3, replacedText = '') => {
  if (typeof input !== 'string' || input.trim() === '') {
    return '';
  }

  const strongRegex = /<strong>(.*?)<\/strong>/;
  const match = input.match(strongRegex);

  if (!match) {
    return '';
  }

  const highlightedWord = match[1];
  const strongText = match[0];
  const strongIndex = input.indexOf(strongText);

  if (strongIndex === -1) {
    return '';
  }

  const beforeText = input.substring(0, strongIndex);
  const afterText = input.substring(strongIndex + strongText.length);

  const beforeWords = beforeText.split(/\s+/);
  let afterWords = afterText.split(/\s+/);

  let suffix = '';

  if (highlightedWord.trim()) {
    const suffixCharMatch = afterText.match(/^([a-z]+)/i);
    suffix = suffixCharMatch ? suffixCharMatch[1] : '';

    if (suffix && afterWords.length > 0 && afterWords[0].startsWith(suffix)) {
      afterWords[0] = afterWords[0].slice(suffix.length);
      if (afterWords[0] === '') afterWords.shift();
    }
  }

  const start = Math.max(0, beforeWords.length - nearbyWordsCount);
  const end = Math.min(afterWords.length, nearbyWordsCount);

  const modifiedStrong = `<del>${highlightedWord}</del>${replacedText ? ` <b>${replacedText}</b>${suffix}` : suffix}`;

  const result = [...beforeWords.slice(start), modifiedStrong, ...afterWords.slice(0, end)]
    .map((word) => word + ' ')
    .join('')
    .trim();

  return result;
};
